var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Card",
    { attrs: { "dis-hover": true } },
    [
      _c(
        "Tabs",
        {
          attrs: { animated: false, "capture-focus": true },
          model: {
            value: _vm.userType,
            callback: function ($$v) {
              _vm.userType = $$v
            },
            expression: "userType",
          },
        },
        [
          _c(
            "TabPane",
            { attrs: { label: "外部客户", name: "externalCustomer" } },
            [
              _vm.userType === "externalCustomer"
                ? _c("ExternalCustomerUserList")
                : _vm._e(),
            ],
            1
          ),
          _c(
            "TabPane",
            { attrs: { label: "内部客户", name: "binfenCustomer" } },
            [
              _vm.userType === "binfenCustomer"
                ? _c("BinFenCustomerUserList")
                : _vm._e(),
            ],
            1
          ),
          _c(
            "TabPane",
            { attrs: { label: "查找客户", name: "CustomerSearch" } },
            [_c("CustomerSearchList")],
            1
          ),
          _c(
            "TabPane",
            { attrs: { label: "客户信息操作日志", name: "CustomerLog" } },
            [_vm.userType === "CustomerLog" ? _c("CustomerLogList") : _vm._e()],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }